var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-title"},[_c('app-i18n',{attrs:{"tag":"p","code":_vm.titleI18nCode}}),_c('app-separator',{staticClass:"form-title__separator"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }